import "./CollegeItem.scss";
import { images } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import {
  removeCollegeInformation,
  setCollegeInformation,
  setCollegeToDeleting,
  setCollegeToUpdating,
  // updateCollege, // <- mirar bien como se hace por ahora no(fav)
} from "../../actions/college";
import { openModal } from "../../actions/ui";
import Modal from "../Modals/Modal";
import InfoCard from "../generalComponents/InfoCard";

const CollegeItem = ({ college }) => {
  //REDUX
  const { collegeInfo } = useSelector((state) => state.colleges);
  const { modalOpen } = useSelector((state) => state.ui);

  //DISPATCH
  const dispatch = useDispatch();

  //HANDLERS
  const handleShow = (college) => {
    dispatch(setCollegeInformation(college));
    dispatch(openModal());
  };

  const handleEdit = (college) => {
    dispatch(setCollegeToUpdating(college));
    dispatch(openModal());
  };

  const handleDelete = (collegeId) => {
    dispatch(setCollegeToDeleting(collegeId));
    dispatch(openModal());
  };

  return (
    <div className="college-item">
      <div className="college-item__heading">
        <div className="college-item__heading--img">
          <img src={images.IconCollegeR} alt="" />
        </div>

        <div className="college-item__heading--name">
          <h3
            className="title-gray-bold-16 set-pointer"
            onClick={() => handleShow(college)}
          >
            {college.name}
          </h3>
        </div>
      </div>

      <div className="icons">
        {/* <button
          className="icons__fav"
          onClick={() => {
            handleFavorite(college);
          }}
        >
          <img
            src={
              college.status === "selected" ? images.IconFavActive : images.IconFavDisable
            }
            alt="icon to edit a college"
          />
        </button> */}

        <button className="icons__edit" onClick={() => handleEdit(college)}>
          <img src={images.IconEdit} alt="icon to edit a college" />
        </button>

        <button
          className="icons__remove"
          onClick={() => handleDelete(college._id)}
        >
          <img src={images.IconDelete} alt="icon to remove college" />
        </button>
      </div>

      {modalOpen && collegeInfo ? (
        <Modal clean={removeCollegeInformation}>
          <InfoCard info={collegeInfo} />
        </Modal>
      ) : null}
    </div>
  );
};

export default CollegeItem;
